import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { PageShell } from "./components/site/PageShell";
import { Hero } from "./components/site/Hero";
import { PathCards } from "./components/site/PathCards";
import { Hospice } from "./components/site/Hospice";
import { WhatIsEcoversity } from "./components/site/WhatIsEcoversity";
import { Story } from "./components/site/Story";
import { Founder } from "./components/site/Founder";
import { Offerings } from "./components/site/Offerings";
import { LearningExchanges } from "./components/site/LearningExchanges";
import { Audience } from "./components/site/Audience";
import { JoinVillage } from "./components/site/JoinVillage";
import { InstagramStrip } from "./components/site/InstagramStrip";
import { Enquiry } from "./components/site/Enquiry";

const SEO = {
  home: { path: "/", title: "Nia Ecoversity — Ecological Learning, Healing & Community",
    description: "Nia Ecoversity is an ecology for lifelong learning, healing and contribution: skills exchanges, healing practices, retreats on the land and community projects." },
  about: { path: "/about", title: "About Nia Ecoversity — Earth in Hospice & Our Founder",
    description: "Our hospice philosophy, what an ecoversity is, and founder Zarya Thomas's story: how ecological learning, care and responsibility come together at Nia Ecoversity." },
  offerings: { path: "/offerings", title: "What We Offer — Skills Exchanges, Healing & Retreats | Nia",
    description: "Learning and Skills Exchanges, healing practices and one-on-one sessions, retreats and residential programmes on the land, and community projects at Nia Ecoversity." },
  join: { path: "/join", title: "Join the Village — Anchor Persons, Councillors & Partners | Nia",
    description: "An invitation to help grow Nia Ecoversity as an anchor person, wisdom councillor, key partner or learner. Every village needs many voices, not only like-minded ones." },
  contact: { path: "/contact", title: "Contact Nia Ecoversity — Send an Enquiry",
    description: "Send Nia Ecoversity a short enquiry about Learning and Skills Exchanges, healing practices, retreats on the land, community projects, partnering or funding." },
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <PageShell seo={SEO.home}><Hero /><PathCards /><Audience /><InstagramStrip /></PageShell>
);
const About = () => (
  <PageShell seo={SEO.about}><Story headingAs="h1" /><Hospice /><WhatIsEcoversity /><Founder /></PageShell>
);
const OfferingsPage = () => <PageShell seo={SEO.offerings}><Offerings headingAs="h1" /><LearningExchanges /></PageShell>;
const JoinPage = () => <PageShell seo={SEO.join}><JoinVillage headingAs="h1" /></PageShell>;
const ContactPage = () => <PageShell seo={SEO.contact}><Enquiry headingAs="h1" /></PageShell>;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/offerings" element={<OfferingsPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
